import React from "react";
import { extractYouTubeVideoId } from "../../../../common/Utils";

interface Props {
  content: string;
  title: string;
}

export const isYouTubeLink = (url?: string): boolean => !!extractYouTubeVideoId(url);

const getYouTubeThumbnailUrl = (videoId: string) =>
  `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;

const YoutubeStudyMaterialCard: React.FC<Props> = ({ content, title }) => {
  const videoId = extractYouTubeVideoId(content);
  if (!videoId) return null;

  return (
    <div className="mt-2">
      <div className="mb-2">
        <img
          src={getYouTubeThumbnailUrl(videoId)}
          alt={`${title} thumbnail`}
          className="rounded"
          style={{ width: "128px", height: "72px", objectFit: "cover" }}
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = "none";
          }}
        />
      </div>
      <a
        href={content}
        target="_blank"
        rel="noopener noreferrer"
        className="text-primary fs-13"
      >
        <i className="ti ti-external-link me-1" />
        {content}
      </a>
    </div>
  );
};

export default YoutubeStudyMaterialCard;
